import { createFeatureSelector } from "@ngrx/store";
import {
    SmartFormFoldersState,
} from "./model";

export const FORMS_FEATURE_KEY = "vadmin.health.engage.form-pool";

export const getSmartFormsState = createFeatureSelector<SmartFormFoldersState>(FORMS_FEATURE_KEY);
